var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconXCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16429 0 0 7.16429 0 16C0 24.8357 7.16429 32 16 32C24.8357 32 32 24.8357 32 16C32 7.16429 24.8357 0 16 0ZM21.9071 22.0786L19.55 22.0679L16 17.8357L12.4536 22.0643L10.0929 22.075C9.93571 22.075 9.80714 21.95 9.80714 21.7893C9.80714 21.7214 9.83214 21.6571 9.875 21.6036L14.5214 16.0679L9.875 10.5357C9.83184 10.4834 9.8079 10.4178 9.80714 10.35C9.80714 10.1929 9.93571 10.0643 10.0929 10.0643L12.4536 10.075L16 14.3071L19.5464 10.0786L21.9036 10.0679C22.0607 10.0679 22.1893 10.1929 22.1893 10.3536C22.1893 10.4214 22.1643 10.4857 22.1214 10.5393L17.4821 16.0714L22.125 21.6071C22.1679 21.6607 22.1929 21.725 22.1929 21.7929C22.1929 21.95 22.0643 22.0786 21.9071 22.0786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXCircle);
export default __webpack_public_path__ + "static/media/iconXCircle.8c528877.svg";
export { ForwardRef as ReactComponent };